import { createClient } from '@supabase/supabase-js';

// The consolidated AAF Website Tools project uses modern Supabase
// publishable keys (the legacy anon JWT is disabled in that project).
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY) {
  throw new Error('Missing Supabase variables (VITE_SUPABASE_URL / VITE_SUPABASE_PUBLISHABLE_KEY)');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

export default supabase;
